<template>
  <div>
    <div class="address-window" :class="value === true ? 'on' : ''">
      <div class="title">选择地址<span class="iconfont icon-guanbi" @click="closeAddress"></span></div>
      <div class="list" v-if="addressList.length">
        <div class="item acea-row row-between-wrapper" style="padding-bottom:0.2rem; height:1.8rem;" :class="item.id === checked ? 'font-color-red' : ''" v-for="(item, index) in addressList" @click="tapAddress(index)" :key="index">
          <span class="iconfont icon-ditu" :class="item.id === checked ? 'font-color-red' : ''"></span>
          <div class="addressTxt">
            <div class="name" :class="item.id === checked ? 'font-color-red' : ''">
              {{ item.real_name }}<span class="phone">{{ item.phone }}</span>
            </div>
            <div class="line1">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.detail }}</div>
          </div>

          <div class="acea-row row-middle" style="color:#2c2c2c">
            <div @click.stop="editAddress(index)" style="margin-right: 0.4rem;"><span class="iconfont icon-bianji" style="font-size: 0.3rem;margin-right: 0.1rem;"></span>编辑</div>
            <div @click.stop="delAddress(index)"><span class="iconfont icon-shanchu" style="font-size: 0.3rem;margin-right: 0.1rem;"></span>删除</div>
          </div>

          <span class="iconfont icon-complete" :class="item.id === checked ? 'font-color-red' : ''"></span>
        </div>
      </div>
      <div class="pictrue" v-if="addressList.length < 1">
        <img src="@assets/images/noAddress.png" class="image" />
      </div>
      <div class="addressBnt bg-color-red" style="margin: 0.4rem auto;" @click="goAddressPages">
        新加地址
      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="value === false" @click="closeAddress"></div>
  </div>
</template>
<script>
import { getAddressList, getAddressRemove } from "../api/user";

export default {
  name: "AddressWindow",
  props: {
    value: Boolean,
    checked: Number,
  },
  data: function() {
    return {
      addressList: [],
      current: 0,
      cartId: 0,
      pinkId: 0,
      couponId: 0,
    };
  },
  mounted: function() {},
  methods: {
    getAddressList: function() {
      let that = this;
      getAddressList().then((res) => {
        that.addressList = res.data;
      });
    },
    /**
     * 编辑地址
     */
    editAddress: function(index) {
      this.$router.push({
        path: "/user/add_address/" + this.addressList[index].id,
      });
    },
    /**
     * 删除地址
     */
    delAddress: function(index) {
      let that = this;
      let address = this.addressList[index];
      let id = address.id;
      getAddressRemove(id).then(function() {
        that.$dialog.toast({
          mes: "删除成功!",
          callback: () => {
            that.addressList.splice(index, 1);
            that.$set(that, "addressList", that.addressList);
          },
        });
      });
    },
    closeAddress() {
      this.$emit("input", false);
    },
    goAddressPages: function() {
      this.$router.push({ path: "/user/add_address" });
      this.$emit("redirect");
    },
    tapAddress: function(index) {
      this.$emit("checked", this.addressList[index]);
      this.$emit("input", false);
    },
  },
};
</script>
